module.exports = __webpack_public_path__ + "img/previous_icon.ba395c09.svg";